import { useEffect, useState } from "react";
import { parseJsonResponse } from "../lib/apiClient";

export function useApi<T>(path: string) {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState("");
  const [status, setStatus] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);

  async function load() {
    setLoading(true);
    setError("");
    setStatus(null);
    try {
      const response = await fetch(path);
      const payload = await parseJsonResponse(response);
      setStatus(response.status);
      if (!response.ok) {
        throw new Error(payload.error ?? "تعذر تحميل البيانات.");
      }
      if (payload.error) {
        throw new Error(payload.error);
      }
      setData(payload as T);
    } catch (err) {
      setData(null);
      setError(err instanceof Error ? err.message : "تعذر تحميل البيانات.");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    void load();
  }, [path]);

  return { data, error, status, loading, reload: load };
}
